exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app,body,html{width:100%;height:100%;font-weight:400;background:#fff}input{border:0}.el-tabs--border-card{-webkit-box-shadow:none;box-shadow:none}.el-tabs--border-card>.el-tabs__header{background-color:#fff}.el-tabs--border-card>.el-tabs__header .el-tabs__item{color:#787878;font-size:16px}.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color:#4ec4c7}.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover{color:#4ec4c7!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bd1d630e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 6OFC
// module chunks = 1